import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-43c0582c")
const _hoisted_1 = { class: "layout-header mb-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = { class: "container mx-auto" }
const _hoisted_4 = { class: "card gap- mx-auto grid" }
const _hoisted_5 = { class: "header flex" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "attr-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "attr" }, "Attribute")
], -1)
const _hoisted_7 = { class: "val flex justify-between" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "Pool Details", -1)
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "pl-[12px]" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, "Pool name", -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "Pool symbol", -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "Pool type", -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, "Swap fees", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, "Pool manager", -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, "Pool owner address", -1)
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "py-[12px] pl-[24px] underline" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", null, "Contract address", -1)
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "py-[12px] pl-[24px] underline" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", null, "Creation date", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_router_link, {
        to: _ctx.getReturnRoute({ name: 'pool', params: { id: _ctx.id } })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BalIcon, {
            name: "x",
            size: "lg"
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (token, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: "token-name flex"
                }, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.symbolFor(token.address)), 1),
                  (idx < _ctx.tableData.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "-"))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_BalAssetSet, {
                  size: 18,
                  addresses: _ctx.iconAddresses(_ctx.tableData),
                  width: 32
                }, null, 8, ["addresses"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", null, _toDisplayString(_ctx.pool?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", null, _toDisplayString(_ctx.pool?.symbol), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", null, _toDisplayString(_ctx.pool?.poolType), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          (!_ctx.loadingPool)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.swapFee) + "%", 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_21))
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          (!_ctx.loadingPool)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, "None"))
            : (_openBlock(), _createElementBlock("div", _hoisted_25))
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("a", {
            href: _ctx.poolOwnerLink,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "flex"
          }, [
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.poolOwner), 1),
            (!_ctx.loadingPool)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.arrow,
                  class: "ml-[12px] inline"
                }, null, 8, _hoisted_30))
              : _createCommentVNode("", true)
          ], 8, _hoisted_28)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("a", {
            href: _ctx.poolAddressLink,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "flex"
          }, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.poolAddress), 1),
            (!_ctx.loadingPool)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.arrow,
                  class: "ml-[12px] inline"
                }, null, 8, _hoisted_35))
              : _createCommentVNode("", true)
          ], 8, _hoisted_33)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", null, _toDisplayString(_ctx.creationDate), 1)
        ])
      ])
    ])
  ], 64))
}